import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material"
import { FaChevronCircleRight, FaCircle } from "react-icons/fa"

import AppTheme from "../style/theme/main"
import NavBar from "../component/layout/nav"

import heroBg from "../images/pricing/herobg.svg"
import phoneRibbon from "../images/pricing/phoneGrouped.svg"

export default function PricingPage() {
  return (
    <Box>
      <Box
        // mt="-80px"
        pb={{ xs: "73px", sm: "116px", md: "165px" }}
        color="white"
        px={{ xs: "10px", sm: "16px", md: "23px" }}
        sx={{
          background: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          // background:
        }}
        // pt={{ xs: "12px", sm: "22px", md: "34px" }}
      >
        <Box position={"relative"}>
          <NavBar dark />
        </Box>
        <Stack
          mt={{ xs: "79px", sm: "98px", md: "148px" }}
          textAlign="center"
          alignItems="center"
        >
          <Box maxWidth={"600px"}>
            <Typography
              // letterSpacing="0"
              variant="large"
              fontSize={{ xs: "14px", sm: "22px", md: "31px" }}
              // lineHeight="125.5%"
            >
              WallX offers a pricing plan that’s <br /> adaptable to your
              business
            </Typography>
          </Box>
          <Stack
            spacing={{ xs: "7px", sm: "11px", md: "15px" }}
            mt={{ xs: "32px", sm: "51px", md: "72px" }}
            alignItems="center"
          >
            <Typography
              fontSize={{ xs: "24px", sm: "38px", md: "54px" }}
              fontWeight={"600"}
            >
              0.39%
            </Typography>
            <Typography variant="h5">
            *capped at N1500 for every payout and payments reconciled.
            </Typography>
            <Button
              sx={{
                width: "100%",
                maxWidth: { xs: "139px", sm: "139px", md: "197px" },
                bgcolor: "white",
                color: AppTheme.palette.primary.main,
                textTransform: "capitalize",
                fontSize: {xs:"12px",md:"15px"},
                borderRadius: "30px",
                height: { xs: "33px", md: "46px" },
                ":hover": {
                  bgcolor: "white",
                  color: AppTheme.palette.primary.main,
                },
              }}
              endIcon={<FaChevronCircleRight color={"#7E7ACD"} />}
            >
              Login
            </Button>
          </Stack>
        </Stack>
      </Box>
      <Stack  px={{ xs: "10px", sm: "16px", md: "23px" }} alignItems={"center"} mt={{xs:"22px", sm:"34px", md:"49px"}}>
        <Box
          textAlign={"center"}
          width="100%"
          maxWidth={{sm: "163px", md: "250px" }}
        >
          <Typography
            fontSize={{ xs: "17px", sm: "27px", md: "39px" }}
            fontWeight="500"
          >
            {" "}
            What you get
          </Typography>
          <Typography
            fontSize={"15px"}
           
            // fontWeight={"300"}
            color="#252525"
          >
            WallX simplifies access to a variety of <br /> financial and lifestyle
            services.
          </Typography>
        </Box>
      </Stack>




      <Stack
        alignItems={"flex-end"}
        justifyContent={{xs:"center",sm:"flex-start"}}
        direction="row"
        mt={{xs:"14px", sm:"23px", md:"32px"}}
        mb={{ xs: "24px", sm: "38px", md: "53px" }}
      >
        <Box
          width="100%"
          display={{xs:"none",sm:"block"}}
          maxWidth={{ xs: "220px", sm: "351px", md: "497px" }}
          mr={{ xs: "16px", sm: "26px", md: "36px" }}
        >
          <img src={phoneRibbon} alt="phone ribbon" width="100%" />
          {/* <img src={phoneRibbon} alt="phone ribbon" width="100%" /> */}
        </Box>

        <Box
          mt={{ xs: "43px", sm: "69px", md: "97px" }}
          pl={{ xs: "10px", sm: "22px", md: "32px" }}
          pr={{ xs: "10px", sm: "0px"}}
          mb={{ xs: "18px", sm: "29px", md: "41px" }}
          width="100%"
          maxWidth={{xs:"auto",sm: "163px", md: "232px" }}
        >
          <List disablePadding>
            {[
              "Dedicated QR Code",
              "Multiple Invoice",
              "Sales Record",
              "Instant Notification",
              "Two Virtual Account Numbers",
              "Customer Marketing Tools",
            ].map((item) => (
              <ListItem
                sx={{ mt: { xs: "10px", sm: "16px", md: "23px" } }}
                key={item}
                disablePadding
                disableGutters
              >
                <FaCircle
                  style={{ width: "8px", height: "8px" }}
                  color={AppTheme.palette.primary.main}
                />
                <ListItemText
                  sx={{ ml: { xs: "7px", sm: "11px", md: "15px" }, my: 0 }}
                  primaryTypographyProps={{fontSize:"15px"}}
                  primary={item}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Stack>
    </Box>
  )
}
